import http from "../api/http";
import { api } from "../api/environment";
import { tokenController } from "../api/tokenController";
import { ILoginForm } from "../types/global";

const login = (payload: ILoginForm) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await http.post(`${api.TOKEN_SERVICE}/Authenticate`, payload);

      const user = res.data.user;

      // Persist permission names before stripping from the user object
      const permissionNames: string[] = user.permissionNames ?? [];
      localStorage.setItem("permissionNames", JSON.stringify(permissionNames));

      delete user.permissionNames;
      delete user.roleNames;
      delete user.userName;
      delete user.creationTime;
      delete user.lastLoginTime;

      localStorage.setItem("user", JSON.stringify(res.data.user));
      tokenController.setToken(res.data.accessToken);
      resolve(res);
    } catch (error) {
      reject(error);
    }
  });
};

const logout = () => {
  localStorage.clear();
  tokenController.clearToken();
};

const isAuthenticated = () => {
  const token = tokenController.getToken();

  let expiresAt = token
    ? (tokenController.getExpiresAt() ? tokenController.getExpiresAt() : 0) *
      1000
    : 0;
  return new Date().getTime() < expiresAt;
};

const isAdmin = () => {
  return tokenController.getRole().toLowerCase().includes("admin");
};

const hasPermission = (name: string): boolean => {
  try {
    const raw = localStorage.getItem("permissionNames");
    const perms: string[] = raw ? JSON.parse(raw) : [];
    return Array.isArray(perms) && perms.includes(name);
  } catch {
    return false;
  }
};

export const authService = { login, logout, isAuthenticated, isAdmin, hasPermission };
